<script lang="ts">
	import { createEventDispatcher } from "svelte";

	export let klass = ''
	export let options = []
	export let values: number[] = []

	const dispatch = createEventDispatcher()

	function click(e: any) {
		const value = Number(e.target.value)
		const index = values.findIndex((n) => n === value)
		if (index === -1) {
			dispatch('click', {
				value: [...values, value]
			})
		} else {
			values.splice(index, 1)
			dispatch('click', {
				value: [...values]
			})
		}
	}
</script>

<div class="{klass}">
	{#each options as o(o.id)}
		<label>
		  <input
		  	type="checkbox"
				on:click={click}
				value={o.id}
				bind:group={values}
		  >
		 	<span class="ml-1">{o.label}</span>
		</label>
	{/each}
</div>